const DEFAULT_API_HOST = 'api';

export const resolveApiBaseUrl = (): string => {
    const configured = process.env.REACT_APP_REOPS_API;

    if (process.env.REACT_APP_RUNTIME === 'jest') {
        return configured || 'http://test';
    }

    if (!configured) {
        return `${window.location.protocol}//${DEFAULT_API_HOST}.${window.location.hostname}`;
    }

    if (process.env.NODE_ENV !== 'development') {
        return configured;
    }

    try {
        const configuredOrigin = new URL(configured).origin;

        if (configuredOrigin !== window.location.origin) {
            // Same-origin in dev via webpack proxy (src/setupProxy.js) so custom
            // response headers like x-search-version are readable in the browser.
            return '';
        }
    } catch {
        return configured;
    }

    return configured;
};
